












































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { userManage, userObserver } from './user';
import UserModal from './components/userModal.vue';
import SelectUser from '@/components/selectUser.vue';

type IUserInfo = IUser.IResponse.IUserDetailInfo;

const columns = [
  {
    slots: { title: 'nameTit' },
    dataIndex: 'name',
    width: '20%',
  },
  {
    slots: { title: 'mobileTit' },
    dataIndex: 'mobile',
    // scopedSlots: { customRender: 'teams'},
    width: '20%',
  },
  {
    slots: { title: 'activeTit' },
    dataIndex: 'active',
    scopedSlots: { customRender: 'active'},
    width: '10%',
    align: 'center',
  },
  {
    slots: { title: 'actionTit' },
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: '50%',
    align: 'center',
  },
];

@Component({
  name: 'User',
  components: {
    UserModal,
    SelectUser,
  },
})
export default class User extends Vue {
  @Ref() private readonly userModal!: UserModal;
  private userList: IUserInfo[] = [];
  private searchUserId = '';
  private columns = columns;
  private isMore = true;
  private pagination = {
    pageSize: 10,
    hideOnSinglePage: true,
  };
  private spinning = false;
  private addLoading = false;
  private currentPage = 1;
  get totalPageCount() {
    return Math.ceil(this.userList.length / this.pagination.pageSize);
  }
  get isLastPage() {
    return this.currentPage >= this.totalPageCount;
  }
  private created() {
    this.registEvent();
    this.refreshUsers();
  }
  private destroyed() {
    this.removeEvent();
  }
  private searchUsers(userId?: string) {
    this.spinning = true;
    userManage.requestGetUsers(userId).then((res) => {
      this.updateUserList();
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private refreshUsers() {
    this.searchUserId = '';
    this.searchUsers();
  }
  private handleSearch() {
    this.searchUsers(this.searchUserId);
  }
  private getMoreUsers() {
    this.addLoading = true;
    userManage.requestGetMoreUsers().then((res) => {
      this.addLoading = false;
      this.updateUserList();
    }).catch((err) => {
      this.addLoading = false;
      this.$message.warning(err);
    });
  }
  private registEvent() {
    userObserver.regist('UPDATE_USER_LIST', this.updateUserList);
  }
  private removeEvent() {
    userObserver.remove('UPDATE_USER_LIST', this.updateUserList);
  }
  private updateUserList() {
    this.userList = userManage.data.map((user) => user);
    this.isMore = userManage.isMore;
  }
  private editPermissions(user: IUserInfo, type: 'add' | 'del') {
    userManage.editUser(user);
    this.userModal.showModal('edit-permissions', type);
  }
  private handleUserIdChange(value?: string) {
    this.searchUserId = value ? value : '';
  }
  private handleTableChange(pagination: any) {
    this.currentPage = pagination.current;
  }
  private editRoles(user: IUserInfo, type: 'add' | 'del') {
    userManage.editUser(user);
    this.userModal.showModal('edit-roles', type);
  }
  private editTeams(user: IUserInfo, type: 'add' | 'del') {
    userManage.editUser(user);
    this.userModal.showModal('edit-teams', type);
  }
  private handleActive(user: IUserInfo) {
    const params: IUser.IRequest.IActiveUser = {
      userId: user.id,
      active: !user.active,
    };
    userManage.requestUpdateActive(params).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleDelete(userId: string) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete')}).toString(),
      onOk: () => {
        userManage.requestDeleteUser(userId).then((res) => {
          this.$message.success(res);
        }).catch((err) => {
          this.$message.warning(err);
        });
      },
    });
  }
}
